import React, { createContext, useEffect, useState } from 'react';
import type { ThemeContextType, ThemeProviderProps } from './ThemeProvider.types';
import '../../resources/themes/base.css';
// import '../../resources/themes/override.css';
import '../../resources/themes/light.css';
import '../../resources/themes/dark.css';

const initialValue: ThemeContextType = {
  theme: 'light',
  updateTheme: () => { },
};

export const ThemeContext = createContext<ThemeContextType>(initialValue);

export const ThemeProvider: React.FC<ThemeProviderProps> = (props: ThemeProviderProps) => {
  const [theme, setTheme] = useState(props.theme || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme])

  const updateTheme = (newTheme: string) => {
    setTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
};